import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-presidenti-dettaglio',
  templateUrl: './presidenti-dettaglio.component.html',
  styleUrls: ['./presidenti-dettaglio.component.css']
})
export class PresidentiDettaglioComponent implements OnInit {
  titolo: string = '';
  frmInserimento!: FormGroup;
  objdettaglio: any;
  ValidoDal: any;


  constructor(public dialogRef: MatDialogRef<PresidentiDettaglioComponent>,
    private srvUtilita: UtilitaService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder, 

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.titolo = 'Dettaglio Presidente'
  }

 
  ngOnInit(): void {
    this.frmInserimento = this.fb.group({
      idPresidente: [null],
      CognomeNome: [null],
      ValiditaDal: [null],
      ValiditaAl: [null]
    })

    if (this.data.iValore >= 0) {
      // console.log('ivalore modale', this.data.iValore)
      this.getDettaglio(this.data.iValore)
    } else {
      this.titolo = this.titolo + ' - Inserimento ';

      const currentDate = new Date()
      this.frmInserimento.patchValue({ ValiditaDal: currentDate.toISOString().substring(0, 10) })
      this.frmInserimento.patchValue({ ValiditaAl: currentDate.toISOString().substring(0, 10) })
    }

  }

  getDettaglio(iValore: number) {
    this.srvUtilita.getObj('Utenti/GetPresidentiDettaglio?idPresidente=' + iValore).subscribe((res: any) => {
      this.objdettaglio = res
      console.log('this.objdettaglio', this.objdettaglio)
      this.frmInserimento.patchValue(this.objdettaglio)

      const objValiditaDal = new Date(res.ValiditaDal);
      if (objValiditaDal.getHours() == 0)
        objValiditaDal.setHours(12);
      this.frmInserimento.patchValue({ ValiditaDal: objValiditaDal.toISOString().substring(0, 10) })

      const objValiditaAl = new Date(res.ValiditaAl);
      if (objValiditaAl.getHours() == 0)
        objValiditaAl.setHours(12);
      this.frmInserimento.patchValue({ ValiditaAl: objValiditaAl.toISOString().substring(0, 10) })

    })
  }


  btnSalva() {
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    let dDataAppoggio = new Date(objInserimento.ValiditaDal);
    objInserimento.ValiditaDal = dDataAppoggio;

    dDataAppoggio = new Date(objInserimento.ValiditaAl);
    objInserimento.ValiditaAl = dDataAppoggio;

  //  console.log('objinserimento', objInserimento)


    if (this.data.iValore > 0) {
      objInserimento.idPresidente = this.data.iValore
    }
    else {
      objInserimento.idPresidente = -1;
    }

    this.srvUtilita.postObj('Utenti/PostPresidenti', objInserimento).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
    }, (err: any) => {
      // console.log('Errore: I dati non sono stati inseriti in modo corretto');
      this.showMessage('Errore: I dati non sono stati inseriti in modo corretto.', 'OK')
    })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnAnnulla(): void {
    this.showMessage('Operazione annullata.', 'OK')
    this.dialogRef.close()
  }

}
